<template>
  <router-view />
</template>

<script>
export default {
  name: "Supplements",
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>